export function setSeatIsAvailable(seat) {
  let isAvailable = false;
  if (seat.Type == 4) {
    // Gallary
    isAvailable = false;
  } else if (seat.Type == 5) {
    // Lavatory
    isAvailable = false;
  } else if (seat.Status == 1) {
    isAvailable = true;

    if ((seat.Characterstics & 2) > 0) {
      // Premium
      // eslint-disable-next-line no-empty
    } else if ((seat.Characterstics & 4) > 0) {
      // Restricted
      isAvailable = false;
    } else if ((seat.Characterstics & 1) > 0) {
      // Handicap
      isAvailable = true;
    } else if ((seat.Characterstics & 3) > 0) {
      // Premium
      isAvailable = true;
    } else if ((seat.Characterstics & 16) > 0) {
      // Preferential
      isAvailable = true;
    }
  } else if (seat.Status == 2 || seat.Type == 0) {
    // Occupied Seats
    isAvailable = false;
  } else if (seat.Status == 0) {
    // No Seat
    if ((seat.Characterstics & 4) > 0) {
      // Restricted
      isAvailable = false;
    } else {
      isAvailable = false;
    }
  } else if (seat.Type == 2) {
    // bulk head
    isAvailable = false;
  }
  return isAvailable;
}
